<div class="dialog">
  <h2 mat-dialog-title><b>{{dialogData.title}}</b></h2>
    <mat-dialog-content class="dialog-content">
        <p class="dialog-message">{{dialogData.dialogMessage}}</p>
        <mat-form-field>
            <mat-label>{{dialogData.datePickerLabel}}</mat-label>
            <mat-date-range-input [rangePicker]="picker" [min]="today" [formGroup]="dateForm">
                <input matStartDate placeholder="Start date" id="startDate" formControlName="startDate" readonly>
                <input matEndDate placeholder="End date" id="endDate" formControlName="endDate" readonly>
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions class="action-buttons">
      <button mat-button (click)="onCancel()" class="cancel-btn">{{ dialogData.cancelButtonText }}</button>
        <button mat-button cdkFocusInitial 
            (click)="setTaskDuration(dialogData.task, dateForm.value.startDate, dateForm.value.endDate)" 
            class="confirm-btn">
            {{ dialogData.confirmButtonText}}
        </button>
    </mat-dialog-actions>
</div>